import { Outlet, useLocation } from 'react-router-dom'
import AuthProvider from '@/auth/AuthProvider'
import UserProvider from '@/user/UserProvider'
import AccountProvider from '@/account/AccountProvider'
import { useOnboardingContainerLogic } from './layout/useOnboardingContainerLogic'
import { OnboardingFlowProvider } from './context/OnboardingFlowProvider'
import { APP_ROUTES } from '@/common/constants'
import { routeNeedsAccounts } from '@/common/navigation/accountRoutes'
import { useUser } from '@/user/useUser'

const OnboardingContainerInner = ({ flowType }: { flowType: 'new-account' | 'invite' }) => {
    const { pathname } = useLocation()
    const user = useUser()
    const needsAccounts = routeNeedsAccounts(pathname)

    const inner = (
        <OnboardingFlowProvider flowType={flowType}>
            <Outlet />
        </OnboardingFlowProvider>
    )

    return needsAccounts ? <AccountProvider user={user}>{inner}</AccountProvider> : inner
}

/** Production page — wires useOnboardingContainerLogic result to providers.
 *  Analytics tracking is kept in the hook for testability.
 */
export const OnboardingContainer = () => {
    useOnboardingContainerLogic()
    const { pathname } = useLocation()

    // Determine flow type based on route: AccountConfirmation and AccountCreated are invite-only flows
    const isInviteFlow =
        pathname.includes(APP_ROUTES.ACCOUNT_CONFIRMATION) || pathname.includes(APP_ROUTES.ACCOUNT_CREATED)
    const flowType = isInviteFlow ? 'invite' : 'new-account'

    return (
        <AuthProvider>
            <UserProvider>
                <OnboardingContainerInner flowType={flowType} />
            </UserProvider>
        </AuthProvider>
    )
}
